import { Href } from 'expo-router';

export const getAssetDetailsHref = (assetId: string): Href => ({
  pathname: '/(tabs)/asset/[assetId]',
  params: { assetId }
});
